export { MasterDetailModule } from "./masterDetailModule";
